import { rpc } from "trader.ts/network";
import { reporterrorSpec } from "../../routes";
import { isNil, isObject, isString } from "../../lib/istype";

function doReport(err: unknown) {
  if (isNil(err)) {
    return;
  }
  const errName =
    isObject(err) && "name" in err && isString(err.name) ? err.name : "";
  const errMessage =
    isObject(err) && "message" in err && isString(err.message)
      ? err.message
      : "";
  if (
    errName === "AbortError" ||
    errMessage === "Load failed" ||
    errMessage === "Failed to fetch" ||
    errMessage === "Fetch is aborted" ||
    errMessage === "Failed to contact server: timeout" ||
    (err &&
      typeof err === "object" &&
      "stack" in err &&
      isString(err.stack) &&
      err.stack.includes("chrome-extension"))
  ) {
    return;
  }

  const error: string =
    err instanceof Error
      ? `${errName}
${errMessage}
${err?.stack || ""}
`
      : JSON.stringify(err);
  void rpc(reporterrorSpec, undefined, {
    error: `${error}

Location: ${window.location.toString()}
User Agent: ${window.navigator.userAgent}
`,
  });
}

export function registerUncaughtErrorReporter() {
  window.addEventListener("unhandledrejection", function (event) {
    doReport(event.reason);
  });
  window.addEventListener("error", function (event) {
    doReport(event.error);
  });
}
